"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.starts-with");
var _shopList = require("@/api/shop/shopList");
var _wechatEvaluate = require("@/api/evaluate/wechatEvaluate");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'wechatEvaluate',
  data: function data() {
    return {
      // 当前激活的标签页
      activeTab: 'all',
      storeList: [],
      tableLoading: true,
      // 日期范围（用于datetimerange选择器）
      dateRange: null,
      // 搜索表单数据
      searchForm: {
        organization: '',
        startDate: null,
        endDate: null
      },
      // 表格数据
      tableData: [],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 3,
      // 和解对话框
      reconciliationDialogVisible: false,
      reconciliationLoading: false,
      reconciliationForm: {
        commentId: '',
        content: '',
        imageList: [],
        picList: []
      },
      currentRow: null
    };
  },
  created: function created() {
    this.getShops();
    this.handleSearch();
  },
  methods: {
    // 日期范围变化处理
    handleDateRangeChange: function handleDateRangeChange(value) {
      if (value && value.length === 2) {
        this.searchForm.startDate = value[0];
        this.searchForm.endDate = value[1];
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
    },
    // 单选按钮组切换
    handleTabChange: function handleTabChange(value) {
      console.log('切换标签页:', value);
      this.activeTab = value;
      this.loadData();
    },
    getShops: function getShops() {
      var _this = this;
      (0, _shopList.getStoreData)().then(function (res) {
        console.log(res.records);
        _this.storeList = res.records;
      });
    },
    // 获取用户会员卡类型
    getUserRankType: function getUserRankType(userRank) {
      var rank = parseInt(userRank) || 0;
      var rankMap = {
        1: '普卡',
        2: '银卡',
        3: '金卡',
        4: '黑金卡',
        5: '钻石卡'
      };
      return rankMap[rank] || '普通游客';
    },
    // 拼接评论图片URL
    getCommentImageUrl: function getCommentImageUrl(url) {
      if (!url) return '';
      // 如果已经是完整URL，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 拼接CDN前缀
      return process.env.VUE_APP_COMMENT_IMAGE_URL + url;
    },
    // 判断是否是差评且未和解
    isBadCommentUnresolved: function isBadCommentUnresolved(row) {
      var score = row.score || 0;
      var processStatus = row.processstatus || 0;
      // 差评(1-2星) 且 未和解(状态不等于2)
      return score < 3 && processStatus !== 2;
    },
    //时间转换
    formatDate: function formatDate(date) {
      // 检查日期是否有效
      if (!date || date === 'null' || date === 'undefined' || date === 0) {
        return '';
      }
      var dateObj = new Date(+date);
      // 检查日期对象是否有效
      if (isNaN(dateObj.getTime())) {
        return '';
      }
      try {
        var formatB = function formatB(t) {
          return new Intl.DateTimeFormat('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
          }).format(t).replace(/\//g, '-').replace(/\s/, ' ').replace(/:/g, ':');
        };
        return formatB(dateObj);
      } catch (error) {
        console.error('日期格式化错误:', error, '输入值:', date);
        return '';
      }
    },
    // 搜索方法
    handleSearch: function handleSearch() {
      console.log('搜索条件:', this.searchForm);
      this.loadData();
    },
    // 导出方法
    handleExport: function handleExport() {
      this.$message.success('开始下载消息数据');
      // 这里可以调用API下载数据
    },
    // 回复操作
    handleReply: function handleReply(row) {
      var _this2 = this;
      this.$prompt('请输入回复内容', '回复评价', {
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPlaceholder: '请输入回复内容...'
      }).then(function (_ref) {
        var value = _ref.value;
        var params = {
          "commentId": row.commentid,
          "content": value
        };
        (0, _wechatEvaluate.replyComment)(params);
        _this2.loadData();
        console.log('回复评价:', row, '回复内容:', value);
        _this2.$message.success('回复成功');
      }).catch(function () {
        _this2.$message.info('已取消回复');
      });
    },
    // 打开和解对话框
    openReconciliationDialog: function openReconciliationDialog(row) {
      console.log('打开和解对话框，row.commentid:', row.commentid, '类型:', (0, _typeof2.default)(row.commentid));
      console.log('完整的 row 数据:', row);
      this.currentRow = row;
      this.reconciliationForm = {
        commentId: row.commentid,
        content: '',
        imageList: [],
        picList: []
      };
      this.reconciliationDialogVisible = true;
    },
    // 关闭和解对话框
    handleReconciliationClose: function handleReconciliationClose() {
      this.reconciliationDialogVisible = false;
      this.reconciliationForm = {
        commentId: '',
        content: '',
        imageList: [],
        picList: []
      };
      this.currentRow = null;
    },
    // 图片上传前校验
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    // 自定义图片上传
    handleImageUpload: function () {
      var _handleImageUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var file, formData, res, imageUrl, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              file = _ref2.file;
              formData = new FormData();
              formData.append('file', file);
              _context.prev = 1;
              _context.next = 2;
              return (0, _wechatEvaluate.uploadReconciliationImage)(formData);
            case 2:
              res = _context.sent;
              if (res.data && res.data.code === 200) {
                // 图片需要加上完整URL前缀
                imageUrl = process.env.VUE_APP_COMMENT_IMAGE_URL + res.data.url;
                this.reconciliationForm.imageList.push(imageUrl);
                this.reconciliationForm.picList.push(imageUrl);
                this.$message.success('图片上传成功');
              } else {
                this.$message.error(res.data && res.data.message || '图片上传失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.error('图片上传失败');
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleImageUpload(_x) {
        return _handleImageUpload.apply(this, arguments);
      }
      return handleImageUpload;
    }(),
    // 删除图片
    removeImage: function removeImage(index) {
      this.reconciliationForm.imageList.splice(index, 1);
      this.reconciliationForm.picList.splice(index, 1);
    },
    // 提交和解
    submitReconciliation: function submitReconciliation() {
      var _this3 = this;
      if (!this.reconciliationForm.content || this.reconciliationForm.content.trim() === '') {
        this.$message.warning('请输入和解内容');
        return;
      }
      this.reconciliationLoading = true;
      var params = {
        commentId: this.reconciliationForm.commentId,
        content: this.reconciliationForm.content,
        picList: this.reconciliationForm.picList
      };
      (0, _wechatEvaluate.reconciliation)(params).then(function () {
        _this3.$message.success('和解成功');
        _this3.handleReconciliationClose();
        _this3.loadData();
      }).catch(function (err) {
        _this3.$message.error(err.message || '和解失败');
      }).finally(function () {
        _this3.reconciliationLoading = false;
      });
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 加载数据
    loadData: function loadData() {
      var _this4 = this;
      this.tableLoading = true;
      console.log('加载微信评价数据 - 页码:', this.currentPage, '每页:', this.pageSize, '标签:', this.activeTab);
      this.searchForm = _objectSpread(_objectSpread({}, this.searchForm), {}, {
        page: this.currentPage,
        limit: this.pageSize,
        activeTab: this.activeTab
      });
      // 实际项目中这里会调用API
      (0, _wechatEvaluate.getCommentList)(this.searchForm).then(function (res) {
        _this4.tableData = res.records;
        _this4.total = res.total;
        _this4.tableLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};